import React from 'react';
import MainPAge from './MainPage'
import './App.css';

function App() {
  return (
    <div className="App">
      <MainPAge />
    </div>
  );
}

export default App;
